import { isNumber } from '../../../utils/is-number.es.js';

const isCubicBezier = (easing) => Array.isArray(easing) && isNumber(easing[0]);
const isEasingList = (easing) => Array.isArray(easing) && !isNumber(easing[0]);
const isCustomEasing = (easing) => typeof easing === "object" &&
    Boolean(easing.createAnimation);
const convertEasing = (easing) => isCubicBezier(easing) ? cubicBezierAsString(easing) : easing;
const cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;

export { convertEasing, cubicBezierAsString, isCubicBezier, isCustomEasing, isEasingList };
